var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0373 21.0747C17.0285 21.0747 21.0747 17.0285 21.0747 12.0373C21.0747 7.04615 17.0285 3 12.0373 3C7.04615 3 3 7.04615 3 12.0373C3 17.0285 7.04615 21.0747 12.0373 21.0747Z",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.038 12.973C13.7677 12.973 15.1698 11.5709 15.1698 9.84126C15.1698 8.11162 13.7677 6.70947 12.038 6.70947C10.3084 6.70947 8.90625 8.11162 8.90625 9.84126C8.90625 11.5709 10.3084 12.973 12.038 12.973Z",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1868 18.7032C17.587 17.597 16.7006 16.6725 15.6207 16.0266C14.5408 15.3806 13.307 15.0369 12.0486 15.0316C10.7903 15.0262 9.55363 15.3593 8.46825 15.9961C7.38286 16.6328 6.48868 17.5498 5.87939 18.6508",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/ic_user.7a2a186330c15344eebdd779a4ea42bf.svg";
export { ForwardRef as ReactComponent };